WiseMetering.Collection.Notifications = WiseMetering.Collection.extend({
    model: WiseMetering.Model.Notification,
    url: '/notifications',

    comparator: function(model) {
        return -model.get('created_at');
    }
});
